import { WaterAlertIcon } from './WaterAlertIcon';

/**
 * author: Colton Wiscombe
 * id DDBEC0DB-97A9-439B-9FC0-5A05F51ED5E3
 * name water-alert
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-alert.svg
 * tags
 * - Alert / Error 
 * - Agriculture 
 */
export const InkAlertIcon = WaterAlertIcon;
export default InkAlertIcon